import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { CommonService } from 'src/app/modules/shared/imports/services/common.service';
import { LogisticaService } from '../services/logistica.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { hideSpinner, showSpinner, getConnection, getCurrentUser } from 'src/app/core/services/functions.service';

interface Bodega {
  cod: string;
  nombre: string;
}

@Component({
  selector: 'app-ops-sin-poligono',
  templateUrl: './ops-sin-poligono.component.html',
  styleUrls: ['./ops-sin-poligono.component.scss']
})
export class OpsSinPoligonoComponent implements OnInit, AfterViewInit {

  // ── ViewChilds ────────────────────────────────────────────────────────────────
  @ViewChild('paginator1') paginator1: MatPaginator;
  @ViewChild('sort1')      sort1: MatSort;
  @ViewChild('paginator2') paginator2: MatPaginator;
  @ViewChild('sort2')      sort2: MatSort;

  empresa = '';

  // ── Catálogos compartidos ─────────────────────────────────────────────────────
  storeBodegas: Bodega[] = [];
  departamentosOriginal: any[] = [];
  municipiosOriginal:    any[] = [];
  poligonos:             any[] = [];

  // ════════════════════════════════════════════════════════════════════════════
  //  TAB 1 ─ OPS SIN POLÍGONO
  // ════════════════════════════════════════════════════════════════════════════

  filtroBodega1    = new FormControl();
  bodegasFiltradas1: Observable<Bodega[]>;
  cod_bodega1 = '';

  fechaInicio1Control = new FormControl(null);
  fechaFin1Control    = new FormControl(null);

  depSel1:  string[] = [];
  munSel1:  string[] = [];
  filtroDepto1 = '';
  filtroMun1   = '';

  dataSource1  = new MatTableDataSource<any>([]);
  dataOriginal1: any[] = [];
  selection1   = new SelectionModel<any>(true, []);

  poligonoMasivo1Ctrl = new FormControl();
  busquedaPoligono1   = '';

  cols1 = ['select', 'FECHA_PICKING', 'NUM_ORDEN', 'PEDIDO_SAP',
           'DEPARTAMENTO', 'MUNICIPIO', 'CODIGO_ZONA_SAP', 'BARRIO', 'TIPO_ORDEN', 'poligono'];

  // ════════════════════════════════════════════════════════════════════════════
  //  TAB 2 ─ OPS POR POLÍGONO
  // ════════════════════════════════════════════════════════════════════════════


  // Polígono a consultar (autocomplete igual que bodega)
  filtroPoligonoCtrl = new FormControl();
  poligonoQueryFiltrado: Observable<any[]>;
  id_poligono_buscar = '';

  fechaInicio2Control = new FormControl(null);
  fechaFin2Control    = new FormControl(null);

  depSel2:  string[] = [];
  munSel2:  string[] = [];
  filtroDepto2 = '';
  filtroMun2   = '';

  dataSource2  = new MatTableDataSource<any>([]);
  dataOriginal2: any[] = [];
  selection2   = new SelectionModel<any>(true, []);

  poligonoMasivo2Ctrl = new FormControl();
  busquedaPoligono2   = '';

  cols2 = ['select', 'FECHA_PICKING', 'NUM_ORDEN', 'PEDIDO_SAP',
           'DEPARTAMENTO', 'MUNICIPIO', 'CODIGO_ZONA_SAP', 'BARRIO', 'TIPO_ORDEN', 'poligono'];

  // ─────────────────────────────────────────────────────────────────────────────

  constructor(
    private commonService: CommonService,
    private logisticaService: LogisticaService,
    private helpers: HelpersService
  ) {}

  async ngOnInit(): Promise<void> {
    this.empresa = getConnection() || 'JA';

    const today = new Date();
    this.fechaInicio1Control.setValue(today);
    this.fechaFin1Control.setValue(this.addDays(today, 8));
    this.fechaInicio2Control.setValue(today);
    this.fechaFin2Control.setValue(this.addDays(today, 8));

    showSpinner();
    try {
      await Promise.all([
        this.cargarBodegas(),
        this.cargarDepartamentos(),
        this.cargarMunicipios(),
        this.cargarPoligonos()
      ]);
    } finally {
      hideSpinner();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.dataSource1.paginator = this.paginator1;
      this.dataSource1.sort      = this.sort1;
      this.dataSource2.paginator = this.paginator2;
      this.dataSource2.sort      = this.sort2;
    });
  }

  // ── Bodegas ───────────────────────────────────────────────────────────────────
  async cargarBodegas(): Promise<void> {
    try {
      const bodegas = await this.commonService.findAllBodegas();
      this.storeBodegas = bodegas.data.map((d: any) => ({ cod: d.c_bod, nombre: d.nom }));

      this.bodegasFiltradas1 = this.filtroBodega1.valueChanges.pipe(
        startWith(''), map(v => this._filtrarBodegas(v || ''))
      );
    } catch {
      this.helpers.notifications.errorMessage('No se pudieron cargar las bodegas');
    }
  }

  private _filtrarBodegas(value: string): Bodega[] {
    const q = typeof value === 'string' ? value.toLowerCase() : '';
    return this.storeBodegas.filter(b =>
      b.nombre.toLowerCase().includes(q) || b.cod.toLowerCase().includes(q)
    );
  }

  displayBodega(b?: Bodega): string {
    return b ? `${b.cod} - ${b.nombre}` : '';
  }

  onBodega1Selected(e: any): void { this.cod_bodega1 = e.option.value.cod; }

  // ── Carga de catálogos ────────────────────────────────────────────────────────
  async cargarDepartamentos(): Promise<void> {
    const res = await this.logisticaService.obtener_departamento();
    if (res.success) this.departamentosOriginal = res.data;
  }

  async cargarMunicipios(): Promise<void> {
    const res = await this.logisticaService.obtener_municipio();
    if (res.success) this.municipiosOriginal = res.data;
  }

  async cargarPoligonos(): Promise<void> {
    const res = await this.logisticaService.obtenerPoligonos();
    if (res.success) {
      this.poligonos = res.data;
      this.poligonoQueryFiltrado = this.filtroPoligonoCtrl.valueChanges.pipe(
        startWith(''), map(v => this._filtrarPoligonosAuto(v || ''))
      );
    }
  }

  private _filtrarPoligonosAuto(value: string | any): any[] {
    const q = typeof value === 'string' ? value.toLowerCase() : '';
    return q
      ? this.poligonos.filter(p =>
          p.NOMBRE_POLIGONO?.toLowerCase().includes(q) ||
          p.COD_POLIGONO?.toLowerCase().includes(q))
      : this.poligonos;
  }

  displayPoligono(p?: any): string {
    return p ? `${p.COD_POLIGONO} - ${p.NOMBRE_POLIGONO}` : '';
  }

  onPoligonoQuerySelected(e: any): void {
    this.id_poligono_buscar = e.option.value?.ID_POLI?.toString() || '';
  }

  // ── Getters filtros catálogos (Tab 1) ────────────────────────────────────────
  get depFiltrados1(): any[] {
    const q = this.filtroDepto1.toLowerCase();
    return q ? this.departamentosOriginal.filter(d => d.NOMBRE_DEPARTAMENTO?.toLowerCase().includes(q))
             : this.departamentosOriginal;
  }

  get munFiltrados1(): any[] {
    const q = this.filtroMun1.toLowerCase();
    return q ? this.municipiosOriginal.filter(m => m.NOMBRE_MUNICIPIO?.toLowerCase().includes(q))
             : this.municipiosOriginal;
  }

  // ── Getters filtros catálogos (Tab 2) ────────────────────────────────────────
  get depFiltrados2(): any[] {
    const q = this.filtroDepto2.toLowerCase();
    return q ? this.departamentosOriginal.filter(d => d.NOMBRE_DEPARTAMENTO?.toLowerCase().includes(q))
             : this.departamentosOriginal;
  }

  get munFiltrados2(): any[] {
    const q = this.filtroMun2.toLowerCase();
    return q ? this.municipiosOriginal.filter(m => m.NOMBRE_MUNICIPIO?.toLowerCase().includes(q))
             : this.municipiosOriginal;
  }

  // ── Helpers nombres para trigger de mat-select ────────────────────────────────
  getNombreDepartamento(cod: string): string {
    return this.departamentosOriginal.find(d => d.CODIGO_DEPARTAMENTO === cod)?.NOMBRE_DEPARTAMENTO || cod;
  }

  getNombreMunicipio(cod: string): string {
    return this.municipiosOriginal.find(m => m.CODIGO_MUNICIPIO === cod)?.NOMBRE_MUNICIPIO || cod;
  }

  // ── Polígonos en selects de asignación ───────────────────────────────────────
  get poligonosFiltrados1(): any[] {
    const q = this.busquedaPoligono1.toLowerCase();
    return q ? this.poligonos.filter(p =>
                 p.NOMBRE_POLIGONO?.toLowerCase().includes(q) ||
                 p.COD_POLIGONO?.toLowerCase().includes(q))
             : this.poligonos;
  }

  get poligonosFiltrados2(): any[] {
    const q = this.busquedaPoligono2.toLowerCase();
    return q ? this.poligonos.filter(p =>
                 p.NOMBRE_POLIGONO?.toLowerCase().includes(q) ||
                 p.COD_POLIGONO?.toLowerCase().includes(q))
             : this.poligonos;
  }

  // ── Rango de fechas ───────────────────────────────────────────────────────────
  private addDays(date: Date, days: number): Date {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  get maxFechaFin1(): Date | null {
    const ini = this.fechaInicio1Control.value;
    return ini ? this.addDays(new Date(ini), 8) : null;
  }

  get maxFechaFin2(): Date | null {
    const ini = this.fechaInicio2Control.value;
    return ini ? this.addDays(new Date(ini), 8) : null;
  }

  onFechaInicio1Change(): void {
    const ini = this.fechaInicio1Control.value;
    if (!ini) return;
    const max = this.addDays(new Date(ini), 8);
    const fin = this.fechaFin1Control.value;
    if (!fin || new Date(fin) < new Date(ini) || new Date(fin) > max) {
      this.fechaFin1Control.setValue(max);
    }
  }

  onFechaInicio2Change(): void {
    const ini = this.fechaInicio2Control.value;
    if (!ini) return;
    const max = this.addDays(new Date(ini), 8);
    const fin = this.fechaFin2Control.value;
    if (!fin || new Date(fin) < new Date(ini) || new Date(fin) > max) {
      this.fechaFin2Control.setValue(max);
    }
  }

  // ════════════════════════════════════════════════════════════════════════════
  //  TAB 1 ─ Acciones
  // ════════════════════════════════════════════════════════════════════════════

  async buscar1(): Promise<void> {
    if (!this.cod_bodega1) {
      this.helpers.notifications.errorMessage('Debe seleccionar una bodega');
      return;
    }
    if (!this.fechaInicio1Control.value || !this.fechaFin1Control.value) {
      this.helpers.notifications.errorMessage('Debe seleccionar el rango de fechas');
      return;
    }

    showSpinner();
    try {
      const fi = this.formatearFecha(this.fechaInicio1Control.value);
      const ff = this.formatearFecha(this.fechaFin1Control.value);
      const res = await this.logisticaService.detalle_ordenes_sin_poligono(
        this.empresa, this.cod_bodega1, fi, ff
      );
      if (res.success) {
        this.dataOriginal1 = res.data.map((row: any) => ({ ...row, poligonoAsignado: null }));
        this.aplicarFiltros1();
        this.selection1.clear();
      } else {
        this.helpers.notifications.errorMessage(res.message || 'Error al obtener las OPs');
        this.dataSource1.data = [];
        this.dataOriginal1 = [];
      }
    } finally {
      hideSpinner();
    }
  }

  aplicarFiltros1(): void {
    let d = this.dataOriginal1;
    if (this.depSel1.length > 0) d = d.filter(r => this.depSel1.some(c => r.DEPARTAMENTO?.startsWith(c + '-')));
    if (this.munSel1.length > 0) d = d.filter(r => this.munSel1.some(c => r.MUNICIPIO?.startsWith(c + '-')));
    this.dataSource1.data = d;
    this.selection1.clear();
  }

  limpiarFiltros1(): void {
    this.depSel1 = []; this.munSel1 = [];
    this.filtroDepto1 = ''; this.filtroMun1 = '';
    this.aplicarFiltros1();
  }

  get hayFiltros1(): boolean {
    return this.depSel1.length > 0 || this.munSel1.length > 0;
  }

  limpiar1(): void {
    this.filtroBodega1.setValue('');
    this.cod_bodega1 = '';
    const today = new Date();
    this.fechaInicio1Control.setValue(today);
    this.fechaFin1Control.setValue(this.addDays(today, 8));
    this.limpiarFiltros1();
    this.dataSource1.data = [];
    this.dataOriginal1 = [];
    this.selection1.clear();
    this.poligonoMasivo1Ctrl.setValue('');
  }

  isAllSelected1(): boolean {
    return this.selection1.selected.length === this.dataSource1.data.length && this.dataSource1.data.length > 0;
  }

  toggleAll1(): void {
    this.isAllSelected1() ? this.selection1.clear()
                          : this.dataSource1.data.forEach(r => this.selection1.select(r));
  }

  async asignarMasivo1(): Promise<void> {
    const idPoli = this.poligonoMasivo1Ctrl.value;
    if (!idPoli) { this.helpers.notifications.warningMessage('Seleccione un polígono'); return; }
    if (!this.selection1.selected.length) { this.helpers.notifications.warningMessage('Seleccione al menos una OP'); return; }

    const ordenes = this.selection1.selected.map(r => ({ num_orden: r.NUM_ORDEN }));
    const usuario = getCurrentUser().usuario_aplicativo || '';
    showSpinner();
    try {
      const res = await this.logisticaService.asignar_poligono_ops(this.empresa, idPoli, usuario, ordenes);
      if (res.success) {
        this.selection1.selected.forEach(r => { r.poligonoAsignado = idPoli; });
        this.helpers.notifications.successMessage(`Polígono asignado a ${ordenes.length} OP(s)`);
        this.poligonoMasivo1Ctrl.setValue('');
        this.selection1.clear();
      } else {
        this.helpers.notifications.errorMessage(res.message || 'Error al asignar el polígono');
      }
    } finally { hideSpinner(); }
  }

  limpiarMasivo1(): void {
    this.selection1.selected.forEach(r => { r.poligonoAsignado = null; });
    this.poligonoMasivo1Ctrl.setValue('');
  }

  async guardarIndividual1(row: any): Promise<void> {
    if (!row.poligonoAsignado) { this.helpers.notifications.warningMessage('Seleccione un polígono para esta OP'); return; }
    const usuario = getCurrentUser().usuario_aplicativo || '';
    showSpinner();
    try {
      const res = await this.logisticaService.asignar_poligono_ops(
        this.empresa, row.poligonoAsignado, usuario, [{ num_orden: row.NUM_ORDEN }]
      );
      if (res.success) {
        this.helpers.notifications.successMessage(`Polígono asignado a la OP ${row.NUM_ORDEN}`);
      } else {
        this.helpers.notifications.errorMessage(res.message || 'Error al asignar el polígono');
      }
    } finally { hideSpinner(); }
  }

  // ════════════════════════════════════════════════════════════════════════════
  //  TAB 2 ─ Acciones
  // ════════════════════════════════════════════════════════════════════════════

  async buscar2(): Promise<void> {
    if (!this.id_poligono_buscar) {
      this.helpers.notifications.errorMessage('Debe seleccionar un polígono');
      return;
    }
    if (!this.fechaInicio2Control.value || !this.fechaFin2Control.value) {
      this.helpers.notifications.errorMessage('Debe seleccionar el rango de fechas');
      return;
    }

    showSpinner();
    try {
      const fi = this.formatearFecha(this.fechaInicio2Control.value);
      const ff = this.formatearFecha(this.fechaFin2Control.value);
      const res = await this.logisticaService.ops_por_poligono(
        this.empresa, this.id_poligono_buscar, '', fi, ff
      );
      if (res.success) {
        this.dataOriginal2 = res.data.map((row: any) => ({ ...row, poligonoAsignado: null }));
        this.aplicarFiltros2();
        this.selection2.clear();
      } else {
        this.helpers.notifications.errorMessage(res.message || 'Error al obtener las OPs');
        this.dataSource2.data = [];
        this.dataOriginal2 = [];
      }
    } finally {
      hideSpinner();
    }
  }

  aplicarFiltros2(): void {
    let d = this.dataOriginal2;
    if (this.depSel2.length > 0) d = d.filter(r => this.depSel2.some(c => r.DEPARTAMENTO?.startsWith(c + '-')));
    if (this.munSel2.length > 0) d = d.filter(r => this.munSel2.some(c => r.MUNICIPIO?.startsWith(c + '-')));
    this.dataSource2.data = d;
    this.selection2.clear();
  }

  limpiarFiltros2(): void {
    this.depSel2 = []; this.munSel2 = [];
    this.filtroDepto2 = ''; this.filtroMun2 = '';
    this.aplicarFiltros2();
  }

  get hayFiltros2(): boolean {
    return this.depSel2.length > 0 || this.munSel2.length > 0;
  }

  limpiar2(): void {
    this.filtroPoligonoCtrl.setValue('');
    this.id_poligono_buscar = '';
    const today = new Date();
    this.fechaInicio2Control.setValue(today);
    this.fechaFin2Control.setValue(this.addDays(today, 8));
    this.limpiarFiltros2();
    this.dataSource2.data = [];
    this.dataOriginal2 = [];
    this.selection2.clear();
    this.poligonoMasivo2Ctrl.setValue('');
  }

  isAllSelected2(): boolean {
    return this.selection2.selected.length === this.dataSource2.data.length && this.dataSource2.data.length > 0;
  }

  toggleAll2(): void {
    this.isAllSelected2() ? this.selection2.clear()
                          : this.dataSource2.data.forEach(r => this.selection2.select(r));
  }

  async asignarMasivo2(): Promise<void> {
    const idPoli = this.poligonoMasivo2Ctrl.value;
    if (!idPoli) { this.helpers.notifications.warningMessage('Seleccione un polígono'); return; }
    if (!this.selection2.selected.length) { this.helpers.notifications.warningMessage('Seleccione al menos una OP'); return; }

    const ordenes = this.selection2.selected.map(r => ({ num_orden: r.NUM_ORDEN }));
    const usuario = getCurrentUser().usuario_aplicativo || '';
    showSpinner();
    try {
      const res = await this.logisticaService.asignar_poligono_ops(this.empresa, idPoli, usuario, ordenes);
      if (res.success) {
        this.selection2.selected.forEach(r => { r.poligonoAsignado = idPoli; });
        this.helpers.notifications.successMessage(`Polígono actualizado en ${ordenes.length} OP(s)`);
        this.poligonoMasivo2Ctrl.setValue('');
        this.selection2.clear();
      } else {
        this.helpers.notifications.errorMessage(res.message || 'Error al actualizar el polígono');
      }
    } finally { hideSpinner(); }
  }

  limpiarMasivo2(): void {
    this.selection2.selected.forEach(r => { r.poligonoAsignado = null; });
    this.poligonoMasivo2Ctrl.setValue('');
  }

  async guardarIndividual2(row: any): Promise<void> {
    if (!row.poligonoAsignado) { this.helpers.notifications.warningMessage('Seleccione un polígono'); return; }
    const usuario = getCurrentUser().usuario_aplicativo || '';
    showSpinner();
    try {
      const res = await this.logisticaService.asignar_poligono_ops(
        this.empresa, row.poligonoAsignado, usuario, [{ num_orden: row.NUM_ORDEN }]
      );
      if (res.success) {
        this.helpers.notifications.successMessage(`Polígono actualizado en la OP ${row.NUM_ORDEN}`);
      } else {
        this.helpers.notifications.errorMessage(res.message || 'Error al actualizar el polígono');
      }
    } finally { hideSpinner(); }
  }

  // ── Utilidades ────────────────────────────────────────────────────────────────
  formatearFecha(fecha: Date): string {
    const d = new Date(fecha);
    const dd = d.getDate().toString().padStart(2, '0');
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
  }

  formatearFechaDisplay(fechaStr: string): string {
    if (!fechaStr) return '-';
    try { return new Date(fechaStr).toLocaleDateString('es-CO'); } catch { return fechaStr; }
  }
}
